var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "row clearfix"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('pie-chart', {
    attrs: {
      "data": _vm.chartData,
      "options": _vm.chartOptions
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('bar-chart', {
    attrs: {
      "data": _vm.chartData2,
      "options": _vm.chartOptions
    }
  })], 1)])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-header"
  }, [_c('h2', [_vm._v("\n                DASHBOARD\n            ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row clearfix"
  }, [_c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box bg-pink hover-expand-effect"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("file_download")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("TOTAL UNDUH")]), _vm._v(" "), _c('div', {
    staticClass: "number count-to",
    attrs: {
      "data-from": "0",
      "data-to": "125",
      "data-speed": "1000",
      "data-fresh-interval": "20"
    }
  }, [_vm._v("15")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box bg-cyan hover-expand-effect"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("share")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("TOTAL SHARE")]), _vm._v(" "), _c('div', {
    staticClass: "number count-to",
    attrs: {
      "data-from": "0",
      "data-to": "257",
      "data-speed": "1000",
      "data-fresh-interval": "20"
    }
  }, [_vm._v("5")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box bg-light-green hover-expand-effect"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("file_upload")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("TOTAL UPLOAD")]), _vm._v(" "), _c('div', {
    staticClass: "number count-to",
    attrs: {
      "data-from": "0",
      "data-to": "243",
      "data-speed": "1000",
      "data-fresh-interval": "20"
    }
  }, [_vm._v("24")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box bg-orange hover-expand-effect"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("person_add")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("TOTAL ANGGOTA")]), _vm._v(" "), _c('div', {
    staticClass: "number count-to",
    attrs: {
      "data-from": "0",
      "data-to": "1225",
      "data-speed": "1000",
      "data-fresh-interval": "20"
    }
  }, [_vm._v("7820")])])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row clearfix",
    attrs: {
      "hidden": "true"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h2', [_vm._v("REAL-TIME CHART")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('div', {
    staticClass: "switch panel-switch-btn"
  }, [_c('span', {
    staticClass: "m-r-10 font-12"
  }, [_vm._v("REAL TIME")]), _vm._v(" "), _c('label', [_vm._v("OFF"), _c('input', {
    attrs: {
      "type": "checkbox",
      "id": "realtime",
      "checked": ""
    }
  }), _c('span', {
    staticClass: "lever switch-col-cyan"
  }), _vm._v("ON")])])]), _vm._v(" "), _c('ul', {
    staticClass: "header-dropdown m-r--5"
  }, [_c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:void(0);",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("more_vert")])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu pull-right"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("Action")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("Another action")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("Something else here")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "flot-chart",
    attrs: {
      "id": "real_time_chart"
    }
  })])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row clearfix",
    attrs: {
      "hidden": "true"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h2', [_vm._v("MULTIPLE AXIS")]), _vm._v(" "), _c('ul', {
    staticClass: "header-dropdown m-r--5"
  }, [_c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:void(0);",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("more_vert")])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu pull-right"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("Action")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("Another action")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("Something else here")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "flot-chart",
    attrs: {
      "id": "multiple_axis_chart"
    }
  })])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row clearfix",
    attrs: {
      "hidden": "true"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h2', [_vm._v("TRACKING")]), _vm._v(" "), _c('ul', {
    staticClass: "header-dropdown m-r--5"
  }, [_c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:void(0);",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("more_vert")])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu pull-right"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("Action")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("Another action")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("Something else here")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "flot-chart",
    attrs: {
      "id": "tracking_chart"
    }
  })])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('h2', [_vm._v("PERSENTASE AKSES")]), _vm._v(" "), _c('ul', {
    staticClass: "header-dropdown m-r--5"
  }, [_c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:void(0);",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("more_vert")])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu pull-right"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("Action")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("Another action")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("Something else here")])])])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('h2', [_vm._v("TRAFFIC VISITOR")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aaf5515e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/Dashboard.vue
// module id = F4tJ
// module chunks = 1